import { abortError, onAbort } from './abort'

const TIMEOUT_ERROR_STRING = 'Timeout waiting for global to become available'

export const waitForGlobal = <T>(
  callback: () => T | undefined,
  {
    interval = 200,
    timeout = 10_000,
    signal,
  }: {
    interval?: number
    timeout?: number
    // Aborting stops the polling and rejects with the abort error.
    signal?: AbortSignal
  } = {}
): Promise<T> => {
  return new Promise((resolve, reject) => {
    const start = Date.now()
    let stopListening = (): void => {}

    const timer = setInterval(() => {
      const value = callback()

      if (value) {
        finish()
        resolve(value)
      } else if (Date.now() - start >= timeout) {
        finish()
        reject(new Error(TIMEOUT_ERROR_STRING))
      }
    }, interval)

    const finish = (): void => {
      clearInterval(timer)
      stopListening()
    }

    stopListening = onAbort(signal, () => {
      finish()
      reject(abortError())
    })
  })
}
